import { Component, Input, Output, EventEmitter, ViewChild, TemplateRef, ElementRef, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BaseComponent, UserService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: "fui-sidebar-filter",
  templateUrl: "sidebar-filter.component.html",
  standalone: false,
})
export class FuiSidebarFilterComponent extends BaseComponent implements OnInit {
  @Input() visible: boolean = false;
  @Input() showHideButton: boolean = true;
  @Input() hideButtonText: string;
  @Input() hideButtonIcon: string = "chevron-left";
  @Input() showSkeleton: boolean = false;
  @Input() skeletonConfig: any;
  @Input() skinnier: boolean = false;
  @Input() inMenu: boolean = false;
  /**
   * Extra class(es) for the rail root, so a caller can restyle its own sidebar without
   * editing the shared rules. This component is used by Products, Exchange, Account and
   * Community — a change to `.fui-sidebar-filter` itself reaches all four.
   */
  @Input() extraClasses: string;
  @Output() hideClicked: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild("sidebarFilterModal") sidebarFilterModal: TemplateRef<any>;
  @ViewChild("contentContainer") contentContainer: ElementRef;
  private contentMoved: boolean = false;
  private currentModalRef: any = null;

  constructor(
    userService: UserService,
    public appService: AppService,
    public translate: TranslateService
  ) {
    super(userService);
  }

  ngOnInit(): void {
    // Set default translated text if not provided via @Input
    if (!this.hideButtonText) {
      this.hideButtonText = this.translate.instant("education.hide_filters");
    }
  }

  showMobileModal(): void {
    if (this.sidebarFilterModal && this.contentContainer) {
      this.currentModalRef = this.appService.showModal(this.sidebarFilterModal, { size: "lg" });

      setTimeout(() => {
        const modalElement = document.querySelector(".modal-body.fui-sidebar-filter-mobile");
        if (modalElement && this.contentContainer) {
          const contentElement = this.contentContainer.nativeElement;
          const mobileElement = modalElement.querySelector("#mobileContentContainer");

          if (mobileElement) {
            while (contentElement.firstChild) {
              mobileElement.appendChild(contentElement.firstChild);
            }
            this.contentMoved = true;
          }
        }
      }, 0);

      this.currentModalRef.closed.subscribe(() => {
        this.moveContentBack();
        this.currentModalRef = null;
      });
      this.currentModalRef.dismissed.subscribe(() => {
        this.moveContentBack();
        this.currentModalRef = null;
      });
    }
  }

  closeMobileModal(): void {
    if (this.currentModalRef) {
      this.currentModalRef.close();
    }
  }

  private moveContentBack(): void {
    if (this.contentMoved && this.contentContainer) {
      const contentElement = this.contentContainer.nativeElement;
      const modalElement = document.querySelector(".modal-body.fui-sidebar-filter-mobile");
      const mobileElement = modalElement?.querySelector("#mobileContentContainer") || modalElement;

      if (mobileElement) {
        while (mobileElement.firstChild) {
          contentElement.appendChild(mobileElement.firstChild);
        }
      }
      this.contentMoved = false;
    }
  }

  onHideClick(): void {
    this.hideClicked.emit();
  }
}
